




































import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import WithItemsMixin from "../private/WithItemsMixin";
import AbcCheckbox from "../input/AbcCheckbox.vue";
import { AbcTooltip } from "../directives/AbcTooltip";

@Component({
    components: {
        AbcCheckbox,
    },
    directives: {
        AbcTooltip,
    },
})
export default class AbcList extends Mixins(WithItemsMixin) {
    @Prop({ type: Boolean }) readonly borderLess!: boolean;
    @Prop({ type: Boolean }) readonly withoutSelection!: boolean;
    @Prop({ type: Boolean }) readonly hasFooter!: boolean;
    @Prop({ type: Boolean }) readonly hideCheckbox!: boolean;

    // @Watch("clickedItem")
    // onEnterPressed(val: number) {
    //     this.onClick(val);
    // }

    private get noData() {
        return this.items && this.items.length === 0;
    }

    private onClick(index: number) {
        if (!this.items) {
            return;
        }
        const item = this.items[index];
        if (this.isItemDisabled(item)) {
            return;
        }
        if (!Array.isArray(this.selectedItem) && this.isEqual(this.selectedItem, item)) index = -1;
        this.$emit("select", index);
    }

    private isSelected(item: any): boolean {
        if (!this.withoutSelection) {
            const selected = Array.isArray(this.selectedItem)
                ? this.selectedItem.some((si) => this.isEqual(si, item))
                : this.isEqual(item, this.selectedItem);
            return selected;
        }
        return false;
    }

    private liClass(item: unknown) {
        const selected = Array.isArray(this.selectedItem)
            ? this.selectedItem.some((si) => this.isEqual(si, item))
            : this.isEqual(item, this.selectedItem);
        const disabled = this.isItemDisabled(item);
        // const current = this.curIndex === this.items.findIndex(el => el === item);
        return {
            "opacity-50 ": disabled,
            selectable: !this.withoutSelection && !disabled,
            borderless: this.borderLess,
            "bg-bg-500 dark:bg-bg-dark-500": selected,
        };
    }
}
